module.exports = __webpack_public_path__ + "a00eb46fc53fe921635dbc0ab4fe2fcf.otf";